<template>
  <div class="blocks-builder-listing-header">
    <div class="container">
      <div class="__builder-header-wrapper">
        <div class="__builder-info-wrapper">
          <nuxt-link :to="`/builder/${company.slug}/view`">
            <!--            <div class="__builder-logo-wrapper">-->
            <!--              <img v-lazy-load  :data-src="company.logoUrl" alt="Builder logo" width="200" height="60">-->
            <!--            </div>-->
            <div>
              <h1 class="__builder-name">
                {{ company.name }}
              </h1>
            </div>
          </nuxt-link>
        </div>
        <div v-if="company.phoneNumbers && company.phoneNumbers.data && company.phoneNumbers.data.length" class="__contact-info">
          <ElementsButtonsRegular v-for="(phoneNumber, key) in company.phoneNumbers.data" :key="`phone-number-${key}`" text size="md" :label="phoneNumber" :button-link="`tel:${phoneNumber}`" :append-icon="phoneIcon" @click="triggerPixelLeadEvent('phone')" />
          <!--          <ElementsButtonsRegular text size="md" label="Message Agent" :append-icon="messageIcon" />-->
        </div>
        <!--        <div class="__agent-list &#45;&#45;multiple">-->
        <!--          <div class="__avatar">-->
        <!--            <img v-lazy-load  data-src="https://www.compass.com/m3/2c1f93649ae5d0cee54825f5d926a2229a244206.jpg" alt="Agent avatar">-->
        <!--          </div>-->
        <!--          <div class="__avatar">-->
        <!--            <img v-lazy-load  data-src="https://www.compass.com/m3/2c1f93649ae5d0cee54825f5d926a2229a244206.jpg" alt="Agent avatar">-->
        <!--          </div>-->
        <!--          <span class="__agent-label">Agents</span>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import phoneIcon from '~/assets/images/icons/phone.webp';
import {Company} from '~/@types/company';

const props = defineProps({
  company: {
    type: Object as PropType<Company>,
    required: true,
  },
});

const {$metaPixelTrackEvent} = useNuxtApp();

/**
 * Trigger pixel event
 */
function triggerPixelLeadEvent (type: 'phone' | 'chat') {
  if (!props.company) return;
  // Track meta event
  $metaPixelTrackEvent('Lead', {
    content_name: props.company.name,
    content_category: props.company.profileType ?? 'Builder',
    content_ids: [props.company.did],
    content_type: 'Company',
    lead_type: type,
  });
}
</script>

<style lang="scss">
.blocks-builder-listing-header {
  background: #f1f1f1;
  padding: 8px 0;
  margin-bottom: -3px;

  .__builder-header-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .__builder-info-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;

      a {
        text-decoration: none;
        display: flex;
        align-items: center;
        transition: all 0.2s ease-in-out;

        .__builder-logo-wrapper {
          width: 200px;
          height: 60px;

          img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
          }
        }

        .__builder-name {
          font-size: 20px;
          font-weight: 500;
          line-height: 25px;
          text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
          color: rgba(var(--text-default), 0.8);
        }

        &:hover {
          transform: scale(1.02);
          transition: all 0.2s ease-in-out;
        }
      }
    }

    .__contact-info {
      display: flex;
      margin-top: 5px;

      .el-button-regular {
        margin-right: 20px;
      }
    }

    .__agent-list {
      display: flex;
      position: relative;
      margin-right: 20px;

      .__avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.4);

        &:not(:last-child) {
          margin-right: -20px;
        }

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .__agent-label {
        position: absolute;
        width: 100%;
        bottom: -8px;
        left: 0;
        text-align: center;
        color: rgba(var(--text-dark), 0.5);
        font-size: 12px;
      }

      &.--multiple {
        .__agent-label {
          padding-left: 20px;
        }
      }
    }

    @media screen and (max-width: $grid-md) {
      .__builder-info-wrapper {
        display: flex;
        justify-content: center;

        .__builder-logo-wrapper {
          display: none;
        }

        .__builder-name {
          font-size: 16px;
        }

        .__contact-info {
          flex-direction: column;
        }
      }

      .__agent-list {
        display: none;
      }
    }
  }
}
</style>
